module.exports = __webpack_public_path__ + "img/icon-good-health-and-well-being.a7105140.svg";